import React from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

interface BuyNowButtonProps {
  isPaymentDone: boolean;
  handlePaymentModal: () => void;
  handleDownload: () => void;
  product: any;
}

const BuyNowButton: React.FC<BuyNowButtonProps> = ({
  isPaymentDone,
  handlePaymentModal,
  handleDownload,
  product,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onBuyNowClick = () => {
    const accessToken = Cookies.get('access_token');
    if (accessToken) {
      handlePaymentModal();
    } else {
      toast.error('로그인을 먼저 진행해주세요.');
      navigate('/login');
    }
  };

  return (
    <>
      {isPaymentDone ? (
        <button
          className="bg-black w-full flex items-center Pretendard-Bold justify-center gap-2 tracking-wider border border-transparent hover:bg-opacity-80 hover:border-[#d8e4fc] text-white text-base transition duration-300 font-semibold shadow-md py-2 px-4 rounded-full"
          onClick={handleDownload}
        >
          <MdOutlineFileDownload className="text-white font-bold" />
          다운로드
        </button>
      ) : (
        <button
          className="bg-black w-full h-[50px] border border-transparent hover:bg-opacity-80 hover:border-[#d8e4fc] text-white text-base transition duration-300 Pretendard-Bold tracking-wide shadow-md py-2 px-4 rounded-full"
          onClick={onBuyNowClick}
        >
          {t('buyNow')}
        </button>
      )}
    </>
  );
};

export default BuyNowButton;
